import { render, staticRenderFns } from "./KernelOrder.vue?vue&type=template&id=3cd9e904&"
import script from "./KernelOrder.vue?vue&type=script&lang=js&"
export * from "./KernelOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports